
import { httpService } from "./httpService";




export function initializeServices() {
    httpService.init();
}
